export const CONFIG_BACKEND_URL =
  process.env.REACT_APP_CRM_BACKEND_URL || '/api';
export const CONFIG_WS_URL = process.env.REACT_APP_CRM_BACKEND_SOCKET || null;
export const CONFIG_AUTH = process.env.REACT_APP_AUTH || false;
